const buildTarget = "firebase"
let isDBLocal
let isDesktopVersion
switch (buildTarget) {
    case "firebase":
        isDBLocal = false
        isDesktopVersion = false
        break;
    case "desktop":
        isDBLocal=true
        isDesktopVersion=true
        break;
    case "cloud":
    isDBLocal=true
    isDesktopVersion=false
    default:
        isDBLocal=true
        isDesktopVersion=true
        break;
}


/**
 * True if we are using the acebase server, all true except for the cloud only firebase version.
 */
export const isLocalDatabase = isDBLocal

/**
 * True for desktop/locally hosted versions.
 */
export const isLocalEdition = isDesktopVersion


export const subFolderPath = isLocalDatabase ? "/app" : ""

export const databasePath = "./"
export const databaseName = "mydb"
export const liveTTScoreboardBackgroundColor = "linear-gradient(to top, rgba(90,130,216,1), rgba(205,212,228,1))"
export const liveTTScoreboardColor = "rgb(90, 130, 216)"
export const liveTTScoreboardButtonTextColor = "white"
export const scoreboardBaseURL = process.env.NODE_ENV === "production" ? window.location.origin : "http://localhost:8080"

export function getFirebaseConfig() {
    if (process.env.NODE_ENV === "production") {
        return {
            apiKey: "AIzaSyBvUstSA9UG6peiA122Tk02EzhspCLsC_U",
            authDomain: "livettscoreboard.web.app",
            databaseURL: "https://scoreboard-20871.firebaseio.com",
            projectId: "scoreboard-20871",
            storageBucket: "scoreboard-20871.appspot.com",
            messagingSenderId: "170946083812",
            appId: "1:170946083812:web:69a746644dae06d7"
        }
    }
    else {
        return {
            apiKey: "AIzaSyDjKg2BWqzGlO88tEptpZO-ZBul6yDjv-o",
            authDomain: "livestreamscoreboard.firebaseapp.com",
            databaseURL: "https://livestreamscoreboard.firebaseio.com",
            projectId: "livestreamscoreboard",
            storageBucket: "livestreamscoreboard.appspot.com",
            messagingSenderId: "587435754887",
            appId: "1:587435754887:web:4457669fb3eeefd54bbf22"
        }
    }
}